// Third-party
import React from 'react';
import { withFormik, FormikProps, Form } from 'formik';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';

// Utils
import { formatMessage } from '../../../utils/i18n';

// Components
import { Button } from '@capintel/component-lib/button';
import { FormInput } from '../../components/forms';
import { FormattedMessageV2 } from '@/views/components/i18n';

interface FormProps {
  email: string;
}

interface ParentProps {
  onSubmit: (email: string) => Promise<void>;
}

type Props = ParentProps & FormikProps<FormProps>;

const canSubmit = (props: Props) => {
  const { values, initialValues, isSubmitting, errors } = props;

  const hasErrors = Object.keys(errors).length > 0;
  const isDirty = values !== initialValues;

  return !hasErrors && isDirty && !isSubmitting;
};

const ForgotPassword = (props: Props) => (
  <>
    <FormattedMessageV2 className="form-title" toLocalize="Auth.ForgotPassword.Title" />

    <FormattedMessageV2 className="form-subtitle" toLocalize="Auth.ForgotPassword.SubTitle1" />

    <Form>
      <FormInput name="email" label={formatMessage('Auth.Email')} placeholder="david@capintel.io" />

      <div className="submit-container">
        <Button variant="primary" type="submit" disabled={!canSubmit(props)}>
          {formatMessage('Auth.ForgotPassword.Action')}
        </Button>

        <Link to="login" className="link">
          {formatMessage('Auth.ReturnToLogin')}
        </Link>
      </div>
    </Form>
  </>
);

const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string().email().required(),
});

const formikWrapper = withFormik<Props, FormProps>({
  validationSchema: ForgotPasswordSchema,
  mapPropsToValues: props => ({ email: '' }),
  handleSubmit: ({ email }, { props, resetForm, setSubmitting }) => {
    props
      .onSubmit(email)
      .then(() => {
        resetForm();
      })
      .finally(() => {
        setSubmitting(false);
      });
  },
});

export default formikWrapper(ForgotPassword) as any;
